import { itemForGroup, itemsForOrder } from 'lib/order-helpers';
import axios from 'lib/axios';
import Vue from 'vue';

const order = {
  state: {
    menu: [],
    orders: [],
    settings: {},
    timeSlots: []
  },

  mutations: {
    setMenu: (state, data) => {
      state.menu = data;
    },

    setOrders: (state, data) => {
      state.orders = data;
    },

    setState: (state, { id, orderState }) => {
      const order = state.orders.find(o => o.id === id);
      order.state = orderState;
    },

    destroy: (state, orderId) => {
      state.orders = state.orders.filter(o => o.id !== orderId);
    },

    setSettings: (state, settings) => {
      for (const setting of settings) {
        Vue.set(state.settings, setting.key, setting);
      }
    },

    setTimeSlots: (state, data) => {
      state.timeSlots = data;
    }
  },

  actions: {
    loadMenu: ({ commit }) => {
      try {
        const { data } = window.prismicData.results.find((document) => document.type === 'menu');
        const menuItems = window.prismicData.results.filter((document) => document.type === 'menu_item');

        const menu = data.body.map(group => {
          return {
            title: group.primary.type,
            items: group.items.map(item => itemForGroup(menuItems, item, group.primary.type))
          };
        });

        commit('setMenu', menu);
      } catch (e) {
        console.log(e);
      }
    },

    loadOrders: async ({ commit, state }) => {
      try {
        const { data } = await axios.get('orders');
        const menuItems = window.prismicData.results.filter((document) => document.type === 'menu_item');

        const orders = data.map(o => {
          return { ...o, items: itemsForOrder(o, menuItems) };
        });

        commit('setOrders', orders);
      } catch (e) {
        console.log(e);
      }
    },

    loadAllTimeSlots: async ({ commit, state }, data = null) => {
      try {
        if (!data) {
          const response = await axios.get('all-timeslots');
          data = response.data;
        }

        commit('setTimeSlots', data.timeslots);
      } catch (e) {
        console.log(e);
      }
    },

    loadSettings: async ({ commit }) => {
      try {
        const { data } = await axios.get('all-settings');
        commit('setSettings', data);
      } catch (e) {
        console.log(e);
      }
    },

    saveSettings: async ({ commit, dispatch }, data) => {
      try {
        await axios.put('settings', data);
      } catch (e) {
        console.log(e);
        alert('Något gick fel');
      }
    }
  }
};

export default order;
